import React from "react";
import "./Banner.css";
import {  useNavigate } from "react-router-dom";

function Banner() {
  const navigate=useNavigate();
  return (
    <section className="home-banner">

      <img onClick={()=>navigate("/contact-us")} src={process.env.PUBLIC_URL + '/Assets/Images/home/banner/Banner.png'} alt="home_banner" className="banner-img" />

      <div className="container">
        {/* <div className="banner-text">
          <h1>Unlock Your <br></br>Financial Freedom</h1>
          <p>Unlock the potential for extra income on your terms,<br></br>
            with the tools, supports & flexibility you need to achieve your financial goals.</p>
          <button className="btn btn-secondary" onClick={()=>navigate("/contact-us")}>Join Now</button>
        </div> */}
      </div>
    </section>
  );
}

export default Banner;
